import { UpdateVariableBenefitConfigurationSubmissionData } from './update-variable-benefit-configuration-submission-data';
import { Deserializable } from '../protocols/deserializable';

export class UpdateVariableBenefitConfigurationSubmission implements Deserializable {
  public accountId!: number;
  public new!: UpdateVariableBenefitConfigurationSubmissionData;

  public onDeserialize(): void {
    if (!!this.new) {
      this.new = window?.injector?.Deserialize?.instanceOf(UpdateVariableBenefitConfigurationSubmissionData, this.new);
    }
  }
}
